<template>
  <div class="containerChat">
    <div class="row">
      <div>
      </div>

      
    </div>
    <Chat ref="chatBox" />
  </div>
</template>

<script>
//import DropDown from "../../components/dropdown/DropDown";
import Chat from "./Chat";

export default {
  name: "ChatContainer",
  components: {
    //DropDown,
    Chat
  },
  data() {
    return {
      loading: false,
      atendenteOptions: [],
      etapaOptions: [],
      collapseFiltro: true,
      telefoneInterval: "",
      telefoneDadoGeral: {
        marcaTelefone: "",
        percentualBateria: 0,
        comInternet: false,
        ligadoEnergia: false,
        DataAlteracao: null
      },
      filtro: {
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        numero: "",
        pessoa: "",
        atendentes: null,
        etapas: null,
        status: 0,
        telefone: {},
        isNova: false,
        isSemAtendente: false,
        // isPendente: false,
        ordem: 1,
        periodoConversaInicial: "",
        periodoConversaFinal: ""
      }
    };
  },
  beforeDestroy() {
    clearInterval(this.telefoneInterval);
  },
  mounted() {
    //this.ObterAtendenteSelect2();
  },
  methods: {
    Filtrar() {
      this.$refs.chatBox.onSelectAccountPhoneNumber(this.filtro);
    },
    Limpar() {
      this.filtro.numero = "";
      this.filtro.pessoa = "";
      this.filtro.atendentes = null;
      this.filtro.etapas = null;
      this.filtro.isNova = false;
      // this.filtro.isPendente = false;
      this.filtro.ordem = 1;
      this.filtro.periodoConversaInicial = "";
      this.filtro.periodoConversaFinal = "";
      this.filtro.isSemAtendente = false;
      this.Filtrar();
    },
    ObterEtapaSelect2() {
      if (this.etapaOptions.length > 0) return;

      // this.loading = true;
      this.$http({
        url: "/etapa/obter-select2",
        method: "GET"
      })
        .then((response) => {
          // this.loading = false;
          this.etapaOptions = response.data;
        })
        .catch((erro) => {
          // this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    ObterAtendenteSelect2() {
      if (this.atendenteOptions.length > 0) return;

      // this.loading = true;
      this.$http({
        url:
          "/usuario/obter-select2-atendente/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((response) => {
          // this.loading = false;
          this.atendenteOptions = response.data;
        })
        .catch((erro) => {
          // this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    ObterTelefoneDadoGeral(telefone) {
      if (!telefone || !telefone.id) return;
      this.$http({
        url:
          "telefone/obter-dado-geral/" +
          telefone.id +
          "/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((resposta) => {
          this.telefoneDadoGeral = resposta.data;
          this.MostrarAlertasDadoGeral(resposta.data);
          this.AtivarTelefoneInterval();
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    AtivarTelefoneInterval() {
      if (this.telefoneInterval) return;
      let vm = this;
      this.telefoneInterval = setInterval(function () {
        vm.ObterTelefoneDadoGeral(vm.filtro.telefone);
      }, 1800000);
    },
    MostrarAlertasDadoGeral(dadoGeral) {
      let array = [];

      const telefoneBateriaBaixa = this.$t(
        "sectionConversas.telefoneBateriaBaixa"
      );
      const telefoneSemInternet = this.$t(
        "sectionConversas.telefoneSemInternet"
      );
      const sincronizadorWhatsDesligado = this.$t(
        "sectionConversas.sincronizadorWhatsDesligado"
      );

      if (dadoGeral.percentualBateria <= 15 && !dadoGeral.ligadoEnergia)
        array.push(telefoneBateriaBaixa);

      if (!dadoGeral.comInternet) array.push(telefoneSemInternet);

      let agora = new Date();
      let dataAlteracao = new Date(dadoGeral.dataAlteracao);
      dataAlteracao.setMinutes(dataAlteracao.getMinutes() + 30);
      if (agora > dataAlteracao) array.push(sincronizadorWhatsDesligado);

      if (array.length > 0)
        this.$notify({
          data: array,
          type: "warn",
          duration: 10000
        });
    },
    onSelectedSemAtendente() {
      this.filtro.atendentes = null;
    },
    onClickItemDropDown(e) {
      clearInterval(this.telefoneInterval);
      this.ObterTelefoneDadoGeral(e);
      this.filtro.telefone = e;
      this.$refs.chatBox.onSelectAccountPhoneNumber(this.filtro);
    }
  }
};
</script>

<style lang="scss">
.containerChat {
  max-height: 100% !important;
  overflow: hidden;
}
</style>
